/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S2_Li1Inputs */

const en_guide_json_schema_s2_li1 = /** @type {(inputs: Guide_Json_Schema_S2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>type</strong>: Specifies the data type: <code>"string"</code>, <code>"number"</code>, <code>"integer"</code>, <code>"boolean"</code>, <code>"array"</code>, <code>"object"</code>, <code>"null"</code>`)
};

const ko_guide_json_schema_s2_li1 = /** @type {(inputs: Guide_Json_Schema_S2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>type</strong>: 데이터 타입을 지정: <code>"string"</code>, <code>"number"</code>, <code>"integer"</code>, <code>"boolean"</code>, <code>"array"</code>, <code>"object"</code>, <code>"null"</code>`)
};

const ja_guide_json_schema_s2_li1 = /** @type {(inputs: Guide_Json_Schema_S2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>type</strong>: データ型を指定：<code>"string"</code>、<code>"number"</code>、<code>"integer"</code>、<code>"boolean"</code>、<code>"array"</code>、<code>"object"</code>、<code>"null"</code>`)
};

/**
* | output |
* | --- |
* | "<strong>type</strong>: Specifies the data type: <code>\"string\"</code>, <code>\"number\"</code>, <code>\"integer\"</code>, <code>\"boolean\"</code>, <code>\"array\"</..." |
*
* @param {Guide_Json_Schema_S2_Li1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s2_li1 = /** @type {((inputs?: Guide_Json_Schema_S2_Li1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S2_Li1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s2_li1(inputs)
	if (locale === "ko") return ko_guide_json_schema_s2_li1(inputs)
	return ja_guide_json_schema_s2_li1(inputs)
});